document.addEventListener('DOMContentLoaded', () => {
    // Select all <h2> elements on the page
    const headings = document.querySelectorAll('h2');
    const heroSection = document.querySelector('[id^="Banner-template--"][id$="__image_banner"]');
    const heroHeading = heroSection.querySelector('.banner__heading');
    const heroButton = heroSection.querySelector('.banner__buttons');
    heroHeading.classList.add('tgd-hero-heading-text');
    heroButton.classList.add('tgd-hero-button');
    
    // Add the class "tgd-heading-text" to each <h2> element
    headings.forEach(heading => {
      if (heading !== heroHeading) {
        heading.classList.add('tgd-heading-text');
      }
    });
});